module.exports = __webpack_public_path__ + "img/pre-approve-rejection.fb732080.svg";